<div class="row mb-3 d-none d-lg-flex">
    <div class="col-2 text-center">
        <label
            for="sourceVerifiedNoChange"
            class="col-form-label"
            translate="CONFIRMATION_SOURCE_REPLACEMENTS_VERIFIED_LABEL"
        ></label>
    </div>
    <div class="col-3">
        <label
            for="sourceClassificationName"
            class="col-form-label"
            translate="CONFIRMATION_SOURCE_REPLACEMENTS_CLASSIFICATION_NAME_LABEL"
        ></label>
    </div>
    <div class="col-3">
        <label
            for="sourceMaterialNumber"
            class="col-form-label"
            translate="CONFIRMATION_SOURCE_REPLACEMENTS_MATERIAL_NUMBER_LABEL"
        ></label>
    </div>
    <div class="col-3">
        <label
            for="sourceCalibrationDate"
            class="col-form-label"
            translate="CONFIRMATION_SOURCE_REPLACEMENTS_CALIBRATION_DATE_LABEL"
        ></label>
    </div>
</div>

<div class="text-center" *ngIf="model.sourceReplacements?.value?.length === 0">
    <span translate="CONFIRMATION_SOURCE_REPLACEMENTS_NOT_AVAILABLE"></span>
</div>

<div [formGroup]="sourceReplacementsForm">
    <fieldset *ngFor="let sourceReplacement of model.sourceReplacements.value; index as i">
        <div
            class="row gap-2 gap-lg-0 mb-3"
            [ngClass]="sourceReplacement.changeIndicatorCode === deleteCode ? 'highlight-deleted-controls' : ''"
        >
            <div
                class="col-12 col-lg-2 mt-2 mt-lg-0 text-center d-flex justify-content-end justify-content-lg-center align-items-start gap-2"
            >
                <span
                    *ngIf="sourceReplacement.changeIndicatorCode === deleteCode"
                    class="fst-italic d-lg-none pt-1"
                    translate="CONFIRMATION_SOURCE_REPLACEMENTS_DELETED_RECORD"
                ></span>
                <pace-core-checkbox-input
                    class="align-child-center"
                    [(model)]="sourceReplacement.changeIndicator"
                    (valueChange)="changeIndicatorChanged(sourceReplacement)"
                    *ngIf="!sourceReplacement.isNewEntry"
                    [parentForm]="sourceReplacementsFormChildren"
                ></pace-core-checkbox-input>

                <button
                    type="button"
                    id="btnDelete"
                    class="btn d-lg-none"
                    [ngClass]="sourceReplacement.changeIndicatorCode === deleteCode ? 'btn-success' : 'btn-warning'"
                    (click)="deleteSourceReplacement(sourceReplacement, i)"
                    [attr.aria-label]="('CONFIRMATION_SOURCE_REPLACEMENTS_DELETE_ARIA_LABEL' | translate) + (i + 1)"
                >
                    <fa-icon [icon]="faTrash" *ngIf="sourceReplacement.changeIndicatorCode !== deleteCode"></fa-icon>
                    <fa-icon
                        [icon]="faTrashRestore"
                        *ngIf="sourceReplacement.changeIndicatorCode === deleteCode"
                    ></fa-icon>
                </button>
            </div>
            <div class="col-12 col-lg-3">
                <label
                    for="sourceClassificationName"
                    class="col-form-label d-flex d-lg-none"
                    translate="CONFIRMATION_SOURCE_REPLACEMENTS_CLASSIFICATION_NAME_LABEL"
                ></label>
                <pace-core-text-input
                    id="sourceClassificationName"
                    [(model)]="sourceReplacement.sourceClassification"
                    [parentForm]="sourceReplacementsFormChildren"
                    [ariaLabel]="'CONFIRMATION_SOURCE_REPLACEMENTS_CLASSIFICATION_NAME_LABEL' | translate"
                ></pace-core-text-input>
            </div>
            <div class="col-12 col-lg-3">
                <label
                    for="sourceMaterialNumber"
                    class="col-form-label d-flex d-lg-none"
                    translate="CONFIRMATION_SOURCE_REPLACEMENTS_MATERIAL_NUMBER_LABEL"
                ></label>
                <pace-core-text-input
                    id="sourceMaterialNumber"
                    [(model)]="sourceReplacement.materialNumber"
                    [parentForm]="sourceReplacementsFormChildren"
                    [ariaLabel]="'CONFIRMATION_SOURCE_REPLACEMENTS_MATERIAL_NUMBER_LABEL' | translate"
                ></pace-core-text-input>
            </div>
            <div class="col-12 col-lg-3">
                <label
                    for="sourceCalibrationDate"
                    class="col-form-label d-lg-none"
                    *ngIf="
                        !sourceReplacement.changeIndicator.value && sourceReplacement.changeIndicatorCode !== deleteCode
                    "
                    translate="CONFIRMATION_SOURCE_REPLACEMENTS_CALIBRATION_DATE_LABEL"
                ></label>
                <pace-core-date-input
                    id="sourceCalibrationDate"
                    *ngIf="
                        !sourceReplacement.changeIndicator.value && sourceReplacement.changeIndicatorCode !== deleteCode
                    "
                    [(model)]="sourceReplacement.calibrationDate"
                    (valueChange)="calibrationDateChanged(sourceReplacement)"
                    [parentForm]="sourceReplacementsFormChildren"
                    [ariaLabel]="'CONFIRMATION_SOURCE_REPLACEMENTS_CALIBRATION_DATE_LABEL' | translate"
                >
                </pace-core-date-input>
                <span
                    *ngIf="sourceReplacement.changeIndicatorCode === deleteCode"
                    class="fst-italic d-none d-lg-block pt-1"
                    translate="CONFIRMATION_SOURCE_REPLACEMENTS_DELETED_RECORD"
                ></span>
            </div>
            <div class="col-lg-1 d-none d-lg-block">
                <button
                    type="button"
                    id="btnDelete"
                    class="btn"
                    [ngClass]="sourceReplacement.changeIndicatorCode === deleteCode ? 'btn-success' : 'btn-warning'"
                    (click)="deleteSourceReplacement(sourceReplacement, i)"
                    [attr.aria-label]="('CONFIRMATION_SOURCE_REPLACEMENTS_DELETE_ARIA_LABEL' | translate) + (i + 1)"
                >
                    <fa-icon [icon]="faTrash" *ngIf="sourceReplacement.changeIndicatorCode !== deleteCode"></fa-icon>
                    <fa-icon
                        [icon]="faTrashRestore"
                        *ngIf="sourceReplacement.changeIndicatorCode === deleteCode"
                    ></fa-icon>
                </button>
            </div>
            <hr class="separator d-block d-lg-none" />
        </div>
    </fieldset>
</div>
<hr class="separator d-none d-lg-block" />
<div class="row">
    <div class="col-12 d-flex justify-content-lg-end gap-2 align-items-center">
        <span
            *ngIf="activeSourceReplacements() >= maxSourceReplacements"
            class="fst-italic"
            translate="CONFIRMATION_SOURCE_REPLACEMENTS_MAX_LIMIT_REACHED"
        ></span>
        <button
            type="button"
            class="btn btn-primary"
            [disabled]="activeSourceReplacements() >= maxSourceReplacements"
            (click)="addSourceReplacement()"
            translate="CONFIRMATION_SOURCE_REPLACEMENTS_ADD_LABEL"
        ></button>
    </div>
</div>
